import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '../Themes';

export default StyleSheet.create({
  container: (singleValue, isCurrencyFirst) => ({
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    paddingStart: !singleValue && !isCurrencyFirst ? 60 : 0,
  }),
  farWheelItem: {
    color: Colors.light_grey,
    fontFamily: Fonts.type.bold.fontFamily,
    fontSize: 31.2,
    letterSpacing: -0.41,
    opacity: 0.2,
    ...Platform.select({
      android: {},
      ios: { fontWeight: 'bold' },
    }),
  },
  nearestWheelItem: {
    color: Colors.light_grey,
    fontFamily: Fonts.type.bold.fontFamily,
    fontSize: 37.4,
    letterSpacing: -0.41,
    opacity: 0.4,
    ...Platform.select({
      android: {},
      ios: { fontWeight: 'bold' },
    }),
  },
  selectedWheelItem: {
    color: Colors.ocean,
    fontFamily: Fonts.type.bold.fontFamily,
    ...Platform.select({
      android: {},
      ios: { fontWeight: 'bold' },
    }),
    fontSize: Platform.OS === 'ios' ? 49.9 : 48,
  },
  wheelStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemsStyle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});
